/**
 * @module sagas/AudioPlayer.js
 *
 * This file replaces our ActionRouter and currently calls our Promised based
 * middleware workflow functions. Eventually, all Workflows and ActionCreators
 * should themselves be Sagas.
 */
import * as D from '../deps';

import * as AudioEventHandlers from './AudioEventHandlers';
import * as AudioWorkers from './workers';

export default function getHandlers() {
  return [
    {
      actionType: D.Constants.Listener.ListenerActions.LISTENER_AUTHENTICATED,
      concur: 'takeLatest',
      handler: AudioWorkers.initializeAudio,
    },
    {
      actionType: D.Constants.AudioPlayer.AudioPlayerActions.AUDIO_PLAY_TRACK,
      concur: 'takeLatest',
      handler: AudioWorkers.playTrackWorker,
    },
    {
      actionType: D.Constants.AudioPlayer.AudioPlayerActions.AUDIO_PRELOAD_TRACK,
      concur: 'takeLatest',
      handler: AudioWorkers.preloadTrackWorker,
    },
    {
      actionType: D.Constants.AudioPlayer.AudioPlayerActions.SET_VOLUME,
      concur: 'takeOnly',
      handler: AudioWorkers.onSetVolume,
    },
    {
      actionType: D.Constants.AudioPlayer.AudioPlayerActions.MUTE,
      concur: 'takeOnly',
      handler: AudioWorkers.onMute,
    },
    {
      actionType: D.Constants.AudioPlayer.AudioPlayerActions.UNMUTE,
      concur: 'takeOnly',
      handler: AudioWorkers.onUnmute,
    },
    {
      // UNUSED
      actionType: D.Constants.AudioPlayer.AudioPlayerActions.SET_CURRENT_TIME,
      concur: 'takeOnly',
      handler: AudioWorkers.onSetCurrentTime,
    },
    {
      actionType: D.Constants.Playback.ActionTypes.RELOAD_AUDIOPLAYBACK,
      concur: 'takeOnly',
      handler: AudioWorkers.reloadAudioPlaybackLibrary,
    },
    {
      actionType: D.Constants.AudioPlayer.AudioPlayerActions.PLAYING,
      concur: 'takeOnly',
      handler: AudioWorkers.disableWakeLock,
    },
    {
      actionType: D.Constants.AudioPlayer.AudioPlayerActions.SCRUB_AUDIO,
      concur: 'takeEvery',
      handler: AudioWorkers.scrubAudio,
    },
    {
      actionType: D.Constants.AudioPlayer.AudioPlayerActions.PAUSE,
      concur: 'takeEvery',
      handler: AudioWorkers.onPaused,
    },
    {
      actionType: D.Constants.Playback.ActionTypes.TRACK_COMPLETE_AUDIO_ANALYTICS,
      concur: 'takeEvery',
      handler: AudioEventHandlers.reportTrackCompleteAnalytics,
    },
    {
      actionType: D.Constants.AudioPlayer.AudioPlayerActions.ERROR,
      concur: 'takeLatest',
      handler: AudioEventHandlers.handlePlaybackError,
    },
    {
      actionType: D.Constants.AudioPlayer.AudioPlayerActions.UPDATE,
      concur: 'takeOnly',
      handler: AudioEventHandlers.onUpdate,
    },
    {
      actionType: D.Constants.AudioPlayer.AudioPlayerActions.HANDLE_POST_URL_UPDATE,
      concur: 'takeOnly',
      handler: AudioWorkers.handlePostUrlUpdate,
    },
  ];
}
